import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { t } from 'i18next';
import { Fragment, SetStateAction, useState } from 'react';
import ChevronDownIcon from '../../vector/payment-details/ChevronDownIcon';

export default function ReasonSelectBox({
  array,
  setReasonInfo,
}: {
  array: { label: string; value: string }[];
  setReasonInfo: React.Dispatch<
    SetStateAction<{
      cancelReasonCd: string;
      cancelReasonEtcCtnt: string;
      agree?: boolean;
    }>
  >;
}) {
  const [selected, setSelected] = useState(array[0]);

  return (
    <div className="border border-[#cccccc] rounded-md w-full">
      <Listbox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left focus:outline-none">
            <span className="block truncate max-md:text-base">
              {t(selected.label)}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
              <ChevronDownIcon />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute inquiry-detail mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none max-md:text-base">
              {array.map((list, idx) => (
                <Listbox.Option
                  key={`list-${idx}`}
                  onClick={() => {
                    setReasonInfo((prev) => ({
                      ...prev,
                      cancelReasonCd: list.value,
                    }));
                  }}
                  className="relative py-2 px-4 text-black cursor-pointer bg-white hover:bg-[#ffebe5] hover:text-[#FF7B51] pl-10"
                  value={list}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {t(list.label)}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-[#FF7B51]">
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
